import {putAll, showBeError, takeLatestF} from '@fl/cmsch-fe-library';
import {SagaIterator} from 'redux-saga';
import {opt} from 'ts-opt';
import {call, select, put} from 'typed-redux-saga';

import {Api} from 'api/gen/Api';
import {t} from 'app/translations';
import {simpleTableSelector, getRequestedTableCsvExportParams} from 'utils/tables';

import {animalBrowserAction, GetAnimalsForPrintAction} from '../action';

const tableId = 'calfBrowser';

function* execute({payload}: GetAnimalsForPrintAction): SagaIterator {
    const tableState = opt(yield* select(simpleTableSelector.tableState(tableId)))
        .orCrash('no tableState');

    const {fieldParams} = getRequestedTableCsvExportParams(tableState);

    yield* put(animalBrowserAction.startPrint());
    const response = yield* call(
        Api.getCalvesEarTagsByFarm,
        fieldParams.filters || [],
        {farmId: payload},
    );
    if (response.isSuccess) {
        yield* put(animalBrowserAction.setBullsForExport(response.data.bullsEarTags || []));
        yield* put(animalBrowserAction.setFemalesForExport(response.data.heifersEarTags || []));
    } else {
        yield putAll(showBeError(response, t('animalBrowser')('exportCalvesInFarm')));
    }
    yield* put(animalBrowserAction.printFinished());
}

/**
 * Loads the animal tags needed for the calf print/export modal.
 *
 * @returns The saga watcher for `GET_ANIMALS_FOR_PRINT`.
 */
export function* getAnimalsForPrint(): SagaIterator {
    yield takeLatestF('animalBrowser/GET_ANIMALS_FOR_PRINT', execute);
}
